// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"GlobalAlert_animate-height__2DWSr","GlobalAlert":"GlobalAlert_GlobalAlert__2aWzK","animateHeight":"GlobalAlert_animateHeight__1uppR"};